import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAsideCollapseExpand = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_545_763)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2.75 0.75H21.25C21.25 0.75 23.25 0.75 23.25 2.75V21.25C23.25 21.25 23.25 23.25 21.25 23.25H2.75C2.75 23.25 0.75 23.25 0.75 21.25V2.75C0.75 2.75 0.75 0.75 2.75 0.75Z",
				fill: "none",
				stroke: "currentcolor",
				strokeWidth: 1.5,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.25 0.75V23.25",
				stroke: "currentcolor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.55469 16.4443L11.9991 11.9999L7.55469 7.55542",
				stroke: "currentcolor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				fill: "none"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_545_763",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) }));
});
export default SvgAsideCollapseExpand;
